import { ModelOptions } from './model-options';

export class BooleanModelOptions extends ModelOptions {
    public readonly required: boolean;
    // showLabel option enables to hide label populated using DisplayDecorator in checkbox-input component
    public readonly showLabel: boolean;

    public readonly disabled: boolean;
    public readonly defaultValue: boolean;
    public readonly isBinaryValue: boolean;
    public constructor({
        required = false,
        showLabel = true,
        disabled = false,
        defaultValue = false,
        isBinaryValue = false,
    }: {
        required?: boolean;
        showLabel?: boolean;
        disabled?: boolean;
        defaultValue?: boolean;
        isBinaryValue?: boolean;
    } = {}) {
        super();
        this.required = required;
        this.showLabel = showLabel;
        this.disabled = disabled;
        this.defaultValue = defaultValue;
        this.isBinaryValue = isBinaryValue;
    }
}

export class BooleanModelOptionsFromJson extends BooleanModelOptions {
    public constructor(data: JsonBooleanModelOptions) {
        super({
            required: data.required,
            showLabel: data.showLabel,
            disabled: data.disabled,
            defaultValue: data.defaultValue,
            isBinaryValue: data.isBinaryValue,
        });
    }
}

export interface JsonBooleanModelOptions {
    required: boolean;
    disabled: boolean;
    showLabel: boolean;
    defaultValue: boolean;
    isBinaryValue: boolean;
}
